import Moment from "moment-timezone";
import { extendMoment } from "moment-range";
const moment = extendMoment(Moment);

import explodeTime from "./explodeTime";
import getMinutesIntersectionOfDateRanges from "./get-minutes-intersection-of-date-ranges";
import toNextIsoWeekday from "./toNextIsoWeekday";

const calculateAllowanceForShift = (
  { startDateTime, endDateTime, price },
  { allowances = [], timezone },
) => {
  if (price <= 0) return { allowance: 0 };

  const _startDateTime = timezone
    ? moment(startDateTime).tz(timezone)
    : moment.utc(startDateTime);

  const _endDateTime = timezone
    ? moment(endDateTime).tz(timezone)
    : moment.utc(endDateTime);

  // Create a list of all the day allowances that overlap with the shift duration
  const overlappingAllowances = allowances.filter((allowance) => {
    const allowanceDay =
      allowance.dayOfWeek < _startDateTime.isoWeekday()
        ? toNextIsoWeekday(_startDateTime, allowance.dayOfWeek)
        : _startDateTime.clone().isoWeekday(allowance.dayOfWeek);
    const _allowanceDay = timezone
      ? moment(allowanceDay).tz(timezone)
      : moment.utc(allowanceDay);

    const allowanceStart = _allowanceDay
      .clone()
      .set(explodeTime(allowance.startTime));
    const allowanceEnd = _allowanceDay
      .clone()
      .set(explodeTime(allowance.endTime));

    return (
      allowanceStart.isBefore(_endDateTime) &&
      allowanceEnd.isAfter(_startDateTime)
    );
  });

  // Calculate the total allowance for each allowance percentage that occurs in the overlapping days
  const percentages = overlappingAllowances.reduce((result, allowance) => {
    const allowanceDay =
      allowance.dayOfWeek < _startDateTime.isoWeekday()
        ? toNextIsoWeekday(_startDateTime, allowance.dayOfWeek)
        : _startDateTime.clone().isoWeekday(allowance.dayOfWeek);
    const _allowanceDay = timezone
      ? moment(allowanceDay).tz(timezone)
      : moment.utc(allowanceDay);
    const allowanceStart = _allowanceDay
      .clone()
      .set(explodeTime(allowance.startTime));
    const allowanceEnd = _allowanceDay
      .clone()
      .set(explodeTime(allowance.endTime));
    const allowanceMinutes = getMinutesIntersectionOfDateRanges(
      _startDateTime,
      _endDateTime,
      allowanceStart,
      allowanceEnd,
    );
    result[allowance.allowance] =
      allowance.allowance in result
        ? result[allowance.allowance] + allowanceMinutes
        : allowanceMinutes;
    return result;
  }, {});

  // Calculate the total allowance for the shift by summing up the allowances for each percentage and multiplying by the shift price
  let allowance = 0;
  for (const [percentage, minutes] of Object.entries(percentages)) {
    allowance += (minutes / 60) * (parseFloat(percentage) / 100) * price;
  }
  allowance = parseFloat(allowance.toFixed(2));

  return { ...percentages, allowance };
};

export default calculateAllowanceForShift;



// WEBPACK FOOTER //
// ./src/helpers/calculateAllowanceForShift.js